module.exports = __webpack_public_path__ + "img/TBWTTNL_benefits_variations.31c434fb.png";